import OpportunityForm from './components/OpportunityForm/OpportunityForm.vue'

const modals: KwixeoInterface.DynamicModals = [
  {
    key: 'opportunity-form',
    title: opportunity => opportunity && opportunity.id ? 'opportunities.opportunities.editTitle' : 'opportunities.opportunities.addTitle',
    component: OpportunityForm,
    size: 'lg'
  }
]

export default modals
